
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getStaPage } from "@/api/api-operation-service";
import piSelectCity from "@/components/select-city/select-city.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import selectStation from "@/components/select-station/select-station.vue";
import PiExport from "@/components/pi-export/pi-export.vue";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectCity,
    piSelectOper,
    selectStation,
    PiExport,
    piSelectTableData
    // "pi-safe-password": safePassword
  }
})
export default class PiPileInfo extends mixins(tableMaxHeight) {
  private formInline: objAny = {
    oprPkId: "",
    globalSearch: "",
    // regionId: "",
    // operationType: "",
    // staStatus: "",
    globalPageIndex: 1,
    globalPageSize: 10
    // applyStatus: ""
  };
  private loading = false;
  privilegeVoObj: objAny = {};
  private win: objAny = window;
  total = 0;
  // exportNum = "";
  exportCondition: objAny = {};
  isShowTapout = false;
  // operationStatusList: objAny[] = [];
  // applyStatusList: objAny[] = [];

  // operationTypeList: objAny[] = [];
  // provinceList: objAny[] = [];
  // cityList: objAny[] = [];
  // private staStatusRow: objAny = {};
  // provinceId = "";
  // cityId = "";
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private searchShow = true;
  private applyStatusColor: objAny = {
    "1": "primary",
    "2": "warning",
    "3": "error",
    "4": "green",
    "5": "success",
    "6": "default"
  };
  private allTableData: object[] = [
    {
      title: i18n.t("commonTableName.staPkId"),
      key: "staPkId",
      minWidth: 130
    },
    {
      title: i18n.t("commonTableName.staName"),
      key: "staName",
      minWidth: 180
      // slot: "staName"
    },
    {
      title: i18n.t("pileInfoDetail.staAddress"),
      key: "staAddress",
      minWidth: 100
    },

    {
      title: i18n.t("commonTableName.staStatus"),
      key: "staStatusName",
      minWidth: 120,
      slot: "staStatusName"
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      width: 100
      // align: "center"
    }
  ];

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      if (data[i] !== "" && data[i] !== undefined) {
        json[i] = data[i];
      }
    }
    return json;
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const params = this.formDataNull(this.formInline);
    const ret = await getStaPage(params);
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
    }
    this.loading = false;
  }

  onClickSearch() {
    this.formInline.globalPageIndex = 1;
    if (this.formInline.areaPathList) {
      this.formInline.areaPath = this.formInline.areaPathList.join(",");
    }
    this.exportCondition = Object.assign({}, this.formInline);
    this.getTableList();
  }

  // public tapOutPile(item: objAny) {
  //   this.isShowTapout = true;
  //   this.staStatusRow = item;
  // }

  // 上下线
  // async changeStaStatus(password: string) {
  //   const staStatus = this.staStatusRow.staStatus == 50 ? "5" : "50";
  //   const ret = await updStationStatus({
  //     staPkId: this.staStatusRow.staPkId,
  //     staStatus: staStatus,
  //     password: password
  //   });
  //   if (ret.status === this.$config.apiStatus) {
  //     // this.isShowTapout = false;
  //     this.getTableList();
  //   }
  // }
  // 删除站点
  // async handelStaDel(staPkId: objAny) {
  //   // const staStatus: string = status == 50 ? "5" : "50"; , status: number
  //   const list = [];
  //   list.push(staPkId);
  //   const ret = await oprStaDel({
  //     staPkIds: staPkId
  //   });
  //   if (ret.status === this.$config.apiStatus) {
  //     // this.isShowTapout = false;
  //     this.getTableList();
  //     this.$Message.success("删除站点成功!");
  //   }
  // }

  // public deletePile(row: objAny) {
  //   this.$Modal.confirm({
  //     title: "删除站点",
  //     content: "确定删除站点吗?",
  //     onOk: () => {
  //       this.handelStaDel(row.staPkId);
  //     },
  //     onCancel: () => {
  //       // this.$Message.info("Clicked cancel");
  //     }
  //   });
  // }

  public bindDetail(item: objAny) {
    this["$common"].save("/pile-manage/pile-info/detail", item); // 存在本地
    this["$router"].push("/pile-manage/pile-info/detail");
  }

  public bindPileList(item: objAny) {
    this["$common"].save("pile-info-item", item); // 存在本地
    this["$router"].push("/pile-manage/pile-list?staPkId=" + item.staPkId);
  }

  created() {
    // getOptionList([
    //   optionKey.staStatusObj,
    //   optionKey.autotrophyObj,
    //   optionKey.staApplyStatusObj
    // ]).then(ret => {
    //   this.operationTypeList = ret[optionKey.autotrophyObj];
    //   this.operationStatusList = ret[optionKey.staStatusObj];
    //   this.applyStatusList = ret[optionKey.staApplyStatusObj];
    // });
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    this.$nextTick(() => {
      this.getTableList();
    });
  }

  beforeRouteEnter(to: objAny, from: objAny, next: Function) {
    if (from.path.indexOf(to.path) != -1) {
      // 从子页面回来
      const name = to.path;
      next((that: objAny) => {
        const formInline = that["$common"].get(name);
        that.formInline = Object.assign(that.formInline, formInline);
      });
    } else {
      next();
    }
  }
  beforeRouteLeave(to: objAny, from: objAny, next: Function) {
    const name = from.path;
    this["$common"].save(name, this.formInline);
    next();
  }
}
